import styled from "styled-components"

export const ModalTitle = styled.h4`
  color: ${({ theme }) => theme.header.primary};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 20px;

  flex: 1;
  margin: 0;
`
